import { Button, Card, Container } from "react-bootstrap";
import { portalIcon } from "../lib/appIcons";

/**
 * Anonymous getting-started guide, served at /guide (App.tsx branches on the
 * pathname before auth init, and the server's SPA fallback is anonymous), so
 * the "Getting started" link in access-granted emails works before a user has
 * ever signed in. Static on purpose — no config or auth dependency.
 */
export default function GuidePage() {
  return (
    <Container className="py-5" style={{ maxWidth: 760 }}>
      <div className="text-center mb-4">
        <img src={portalIcon} alt="" style={{ width: 64, height: 64 }} className="rounded-3" />
        <h3 className="mt-3 mb-1">Getting started with the TTS Engineering Portal</h3>
        <p className="text-muted">One place to open every TTS engineering app</p>
      </div>

      <Card className="mb-3">
        <Card.Body className="p-4">
          <h5>What the portal is</h5>
          <p className="mb-0">
            The portal is your landing page for TTS Engineering Apps. After you sign in, it shows a
            card for each application you have access to — such as the DWR App or the Part
            Disposition Tracker. Clicking a card opens that application; there is no business data
            in the portal itself.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-3">
        <Card.Body className="p-4">
          <h5>Signing in</h5>
          <p>Your access email tells you which sign-in applies to you:</p>
          <ul className="mb-0">
            <li>
              <strong>Sign in with Microsoft</strong> — for TTS/RPC staff and invited guest
              accounts. Use the same work account and email address your access was granted to;
              your permissions attach automatically the first time you sign in.
            </li>
            <li>
              <strong>Email and password</strong> — for managed local accounts. You will have
              received an invite email with a one-time link to set your password. If the link has
              expired, ask a TTS administrator to re-send it.
            </li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-3">
        <Card.Body className="p-4">
          <h5>How access works</h5>
          <p>
            Access is role-based and managed centrally by TTS administrators. You only see cards
            for applications you hold a role in, and inside each application your role decides
            what you can do.
          </p>
          <p className="mb-0">
            If an application you expect is missing — or you can sign in but see nothing — you
            have not been granted a role there yet. Contact a TTS administrator to request access.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body className="p-4">
          <h5>Learning each application</h5>
          <p className="mb-0">
            Every application has its own getting-started guide. The access email you received
            links to the guide for each app you were granted, and you can usually find it inside
            the app as well.
          </p>
        </Card.Body>
      </Card>

      <div className="d-grid">
        <Button href="/">Go to the portal</Button>
      </div>
    </Container>
  );
}
